import { useUIColors } from '@/core/hooks';
import HeartHandshakeSvg from '@assets/images/svg/heart-handshake.svg';
import React from 'react';
import { View } from 'react-native';

export interface HeartHandshakeIconProps {
  size?: number;
  color?: string;
}

export const HeartHandshakeIcon = React.memo<HeartHandshakeIconProps>(function HeartHandshakeIcon({
  size = 40,
  color,
}) {
  const colors = useUIColors();
  const stroke = color || colors.vectorsIconGreyscale;

  return (
    <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
      <HeartHandshakeSvg width={size} height={size} stroke={stroke} fill="none" />
    </View>
  );
});

export default HeartHandshakeIcon;